<template>
  <div>
    <b-card-code title="Definición">
      <b-row>
        <b-col md="6">
          <b-form-group label="Nombre Valorización de Nómina" label-for="name">
            <b-form-input id="name" v-model="name" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Parámetro" label-for="parameter">
            <v-select id="parameter" v-model="parameter" :options="parameters_lst" :clearable="false" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="Datos Informados" label-for="fileInput">
            <input type="file" ref="fileInput" id="fileInput" @change="handleFileUpload" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Descargar plantilla de Datos Informados" label-for="fileInput">
            <b-button variant="secondary" @click="download_template">
              <feather-icon icon="DownloadIcon" class="mr-50" />
              <span class="align-middle">Plantilla</span>
            </b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <!-- submit and reset -->
        <b-col md="6">
          <div>
            <b-button variant="primary" @click="save_payroll">
              <feather-icon icon="SaveIcon" class="mr-50" />
              <span class="align-middle">Valorizar Nómina</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card-code>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BFormSelect, BCardText
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import axios from '@axios'

export default {
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BCardText,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      parameters_lst: [],
      parameter: null,
      name: "",
      isDownloading: false,
      inputSpreadsheet: null,
    }
  },
  methods: {
    download_template() {
      const URL2 = '/nomina/template'
      const config = {
        method: 'get',
        url: URL2,
        responseType: 'blob',
        params: {
          user_id: this.getUserID(),
        }
      }
      axios(config)
        .then(response => {
          if (response && response.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(response.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', `template.xlsx`); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
    handleFileUpload() {
      const file = this.$refs.fileInput.files[0];
      if (file && file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.inputSpreadsheet = file
        //this.uploadFile(file);
      } else {
        alert('Please upload a valid .xlsx file');
      }
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('creation_date', '2023-09-23');

      console.log(formData)

      axios.post('/nomina/spreadsheet/', formData).then(response => {
        console.log('File uploaded successfully:', response);
      }).catch(error => {
        console.error('Error uploading file:', error);
      });
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    save_payroll() {
      if (!this.formIsValid()) {
        this.$swal({
          title: 'Formulario Incompleto',
          text: "Por favor completa todos los campos del formulario e intenta nuevamente.",
          icon: 'error',
          confirmButtonText: 'Cerrar',
        })
        return
      }

      let formData = new FormData();
      formData.append('parameter_id', this.parameter.key);
      formData.append('user_id', this.getUserID());
      formData.append('name', this.name);
      formData.append('file', this.inputSpreadsheet);
      formData.append('creation_date', '2023-09-23');

      const URL_api = '/nomina/valuation'

      const config = {
        method: 'post',
        url: URL_api,
        responseType: 'blob',
        data: formData,
      }
      axios(config).then(response => {
        if (response && response.status === 200) {
          // create file link in browser's memory
          const href = window.URL.createObjectURL(response.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', `${this.name}.xlsm`); //or any other extension
          document.body.appendChild(link);

          this.isDownloading = false
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
          //this.$router.push({ name: 'Valuation' })
        }
      })
        .catch(error => {
          console.log(error)
          this.isDownloading = false
          this.printErrorModal(error)
        });
    },
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const id = jsonUserData.id
      return id
    },
    formIsValid() {
      if (!this.parameter) return false
      if (!this.name) return false
      if (!this.inputSpreadsheet) return false

      return true
    },
    getOptionsParameters() {
      const URL = '/nomina/parameter/select'
      const config = {
        method: 'get', url: URL,
      }
      axios(config)
        .then(response => {
          if (response && response.status === 200) {
            this.parameters_lst = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
  },
  mounted() {
  },
  created() {
    this.getOptionsParameters()
  },
  watch: {
    'isDownloading': function (newValue, oldValue) {
      if (newValue) {
        this.$swal({
          title: 'Generando valorización de nómina',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
        })
        this.$swal.showLoading()
      } else {
        this.$swal.close()
      }
    },
  },
}
</script>
